// Static profile info — not CMS-driven. Milestones come from the CMS; this
// is the "who" around them. Edit these values directly for your own site.
export const profile = {
  name: 'Tom (Ju Kyo) Kim',
  title: 'QA Engineer',
  tagline: 'I break things, and complain about them, but get paid to do it.',
  bio: 'QA engineer with 11+ years testing streaming, ad tech, and commerce platforms at NBCUniversal, Disney Streaming, and Yieldmo — currently leading end-to-end integration testing for Peacock billing and subscription stack. I build automation that replaces manual grind: one Appium/Selenium framework covered ~82% of manual cases and cut a release cycle from two weeks to four days. Recently AWS Certified Cloud Practitioner, extending that work into cloud infrastructure and CI/CD.',
  email: 'jukyokim1992@gmail.com',
  links: [
    { label: 'GitHub', url: 'https://github.com/JuKyoKim' },
    { label: 'LinkedIn', url: 'https://linkedin.com/in/jukyokim' },
  ],
};

export interface CategoryMeta {
  label: string;
  color: string;
  icon: string;
}

// Keyed by Category.slug (see apps/blogger/prisma/seed.ts for the seeded
// "portfolio" site categories). Add an entry here whenever a new category is
// created in the CMS so it gets its own icon/color on the timeline.
export const CATEGORY_META: Record<string, CategoryMeta> = {
  experience: {
    label: 'Experience',
    color: '#5b8def',
    icon: 'briefcase',
  },
  education: {
    label: 'Education',
    color: '#9b6bdf',
    icon: 'graduation-cap',
  },
  project: {
    label: 'Project',
    color: '#2fb787',
    icon: 'code',
  },
  achievement: {
    label: 'Achievement',
    color: '#e0a13a',
    icon: 'trophy',
  },
};

export const DEFAULT_CATEGORY_META: CategoryMeta = {
  label: 'Milestone',
  color: '#8a8f98',
  icon: 'flag',
};

export function categoryMetaFor(slug: string | undefined): CategoryMeta {
  if (!slug) return DEFAULT_CATEGORY_META;
  return CATEGORY_META[slug] ?? DEFAULT_CATEGORY_META;
}

// Order suites appear in the Regression Log. Categories not listed here sort
// last, alphabetically — so adding a category in the CMS never breaks the page,
// it just lands at the bottom until it's named here.
export const SUITE_ORDER: string[] = ['experience', 'project', 'achievement', 'education'];

/** Display metadata for a suite (category) in the Regression Log. */
export function suiteMetaFor(slug: string): CategoryMeta {
  return CATEGORY_META[slug] ?? { ...DEFAULT_CATEGORY_META, label: slug };
}
